<template>
  <section>
    <Navbar />

    <section class="everyday-savings">
      <div class="titles">


        <h2>Everyday savings store-wide</h2>
        <p> <img src="../assets/images/coin_in_hand.png" />
        </p>
        <p class="box">There's a huge range of discounts at Booker or Makro that are only available to Just Eat
          restaurants! Whatever you're looking for, you can save money.</p>



        <div class="entries__content">
          <p><input type="text" v-on:keyup="removeReadmore($event)" id="search" name="Search"
              class="input input--search displayed" placeholder="Search for products" v-model="search"
              autoComplete="off" />
            <font-awesome-icon icon='search' class="displayed" />

          </p>

          <p class="box entries__header__search">Search by food e.g 'chips' or 'chicken' to see the discounts</p>


          <table class="entries__content__list">

            <col />
            <col />
            <col />
            <col />
            <col />
            <thead>
              <tr>
                <!--<th>{{ capitalizeFirstLetter(Object.keys(filteredList[0])[0]) }}</th>-->

                <th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[1]) }}</th>
                <!--<th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[2]) }}</th>-->
                <!--<th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[4]) }}</th>-->
                <th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[5]) }}</th>
                <th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[6]) }}</th>
                <th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[8]) }}</th>
                <th>{{ capitalizeFirstLetter(Object.keys(this.entries[0])[10]) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entry, index) in filteredList" :key="index">
                <!--<td>{{ capitalizeFirstLetter(entry.GROUP) }}</td>-->
                <td class="product">
                  <div>{{ entry.PRODUCT }}</div>
                </td>
                <!--<td>{{ removeSpace(entry.SIZE) }}</td>-->
                <!--<td>{{ entry.MIDAS_CODE }}</td>-->
                <td>{{ entry.NORMAL_PRICE }} </td>
                <td>{{ entry.JUST_EAT_PRICE }}</td>
                <td>{{ entry.PERCENT_SAVINGS }}</td>
                <td>{{ entry.VALID_UNTIL }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="read-more" class="box read-more displayed">
          <button @click="onAddcountryClick(10, $event)" class="button">See more</button>
        </div>
        <div id="noresult" class="box"></div>

        <div class="entries__booker">
          <h3>Plus! Earn up to 7% cashback on your spend at Booker or Makro</h3>
          <p>Try our <a href="https://www.just-eat.co.uk/deals/booker-atm/" target="_blank">Cashback Calculator</a> and
            see how much you
            could be earning on your weekly shop.
          </p>
          <p><a href="https://www.just-eat.co.uk/deals/booker-atm/"><img src="../assets/images/booker.png" /></a></p>
        </div>

        <div class="terms">
          <p>All offers are subject to availability. All prices exclude VAT and are correct at the time of publication.
            Excludes PMP and special packs. Maximum 10 cases per product per customer per day and subject to
            availability. Management reserves the right to refuse, withdraw or change the deal without prior
            consultation. See in-store for full terms and conditions. Available for Just Eat partners only.</p>
        </div>

      </div>
    </section>
  </section>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import fontawesome from "@fortawesome/fontawesome";
import brands from "@fortawesome/fontawesome-free-brands";
import solid from "@fortawesome/fontawesome-free-solid";





fontawesome.library.add(brands, solid);

export default {

  name: "MainPage",
  components: {
    Navbar,

  },
  data: function () {
    return {
      search: '',
      entries: [""],
      length: 10,
      countReadclicks: 0,
      mySVG: require('../assets/images/coin_in_hand.svg')

    }
  },
  created() {
    // GET request using fetch with set headers
    const headers = { "Content-Type": "application/json" };
    fetch("https://takeaway-landing-pages.k.elnino-production.com/storage/resources/booker-matrix-exclusive-prices/JusteastExclusives.json", { headers })
      .then(response => response.json())
      .then(data => (this.entries = data));
  
  },
  methods: {

    removeReadmore(event) {
      let noResultsL = this.filteredList.length == 0



      this.$el.querySelector("#search").value.length > 0 ? this.$el.querySelector(".everyday-savings svg").classList.remove("displayed") : this.$el.querySelector(".everyday-savings svg").classList.add("displayed");

      if (noResultsL === true) {
        this.$el.querySelector("#read-more").classList.remove('displayed');

        this.$el.querySelector("#noresult").classList.add('displayed');
        this.$el.querySelector("#noresult").innerHTML = "The item you have searched for is not listed."
      } else if (event.target.value === "") {
        this.length = 10
        this.$el.querySelector("#read-more").classList.add('displayed');
        this.$el.querySelector("#noresult").classList.remove('displayed');
      } else if (this.filteredList.length > -1 && this.filteredList.length !== 10 && event.target.value !== "") {

        this.$el.querySelector("#read-more").classList.remove('displayed');
        this.$el.querySelector("#noresult").classList.remove('displayed');
      }
    },

    capitalizeFirstLetter(string) {
      if(!string) return

      if (string !== null || string !== "") {




        let removeChr = string.replace(/_/g, " ");
        removeChr = removeChr.replace(/percent/g, "%");
        let splitStr = removeChr.toLowerCase().split(' ');

        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }

        splitStr = splitStr.join(' ').replace(/Percent/g, "%");
        return splitStr;

      }
    },
    removeSpace(string) {
      let removeChr = string.replace(/\s/g, '')

      return removeChr;
    },
    onAddcountryClick(no, event) {


      this.countReadclicks++
      if (this.countReadclicks < 2) {
        this.length = this.length + no;
      } else if (this.countReadclicks === 2) {
        //  this.length=JusteastExclusives.length
        event.target.innerHTML = "See all"
        this.length = this.length + no;
      } else if (this.countReadclicks > 2) {
        this.length = this.entries.length
        event.target.parentNode.classList.remove('displayed');
      }

    }
  },

  computed: {
    filteredList() {
      if (this.search === '') return this.entries.slice(0, this.length);
      return this.entries.filter(entry => {
        return (entry.PRODUCT.toLowerCase().includes(this.search.toLowerCase()) || entry.GROUP.toLowerCase().includes(this.search.toLowerCase())) || entry.MIDAS_CODE.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  }
};

</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;





.navbar__container--logo {
  width: 250px;
  margin: 0;
}

.entries {
  &__header {
    &__search {
      font-size: 1em;
    }
  }

  &__content {
    &__list {
      .product div {
        max-width: 80%;
        margin: auto;
      }

      @media only screen and (max-width: 976px) {
        col:nth-child(1) {
          width: 44%;
        }

        col:nth-child(2) {
          width: 12%;
        }

        col:nth-child(3) {
          width: 12%;
        }

        col:nth-child(4) {
          width: 8%;
        }

        col:nth-child(5) {
          width: 26%;
        }
      }
    }
  }
}

.everyday-savings {
  max-width: 863px;
  margin: 0 auto;

  .terms>p {
    font-size: 14px;
  }

  .titles {
    text-align: center;

    img {
      width: 25%;
      margin: 0;

      @media only screen and (max-width: 976px) {
        width: 50%;
      }
    }
  }

  .read-more {
    display: none;
    margin-top: 20px;
  }

  .read-more.displayed {
    display: block;
    margin-top: 20px;
  }

  #noresult {
    display: none;
    margin-top: 20px;
  }

  #read-more button {
    margin: auto;
  }


  #noresult.displayed {
    display: flex;
    color: var(--color-error-1);
  }

  h2 {
    color: var(--color-orange-1);
    font-size: 2em;
  }

  h2,
  p {
    padding: 0px;
    text-align: center;
    margin: 20px auto;
  }



  @media only screen and (max-width: 976px) {
    padding: 0px 10px;
  }


  input {
    width: 100%;
    height: 40px;
    border-radius: 15px;
    padding: 0 15px;
    box-sizing: border-box;
  }

  svg {
    display: none;
    margin: 0 0 18px auto;
    text-align: right;
    margin-top: -45px;
    cursor: pointer;
    color: var(--color-orange-1);
    padding: 15px;
  }

  svg.displayed {
    display: block;
  }
}

ol {
  width: 50%;
}

ol>li {
  width: 100%
}



.framed6:hover {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--color-orange-1);
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.entries {
  &__header {
    &__search {
      font-weight: bold;
    }
  }



  td,
  th {
    border: 1px solid #ddd;
    padding: 2px;
  }

  &__booker {
    text-align: center;
    width: 88%;
    padding: 0 6%;
  }

}


.button {
  background: var(--color-blue-button-1);
  border-radius: 18px;
  padding: 8px 2px;
  color: #fff;
  transition: 0.2s linear;
}

button {
  outline: none;
  -webkit-appearance: none;
  border: none;
  user-select: none;
  background: transparent;
  cursor: pointer;
  padding: 8px 40px;
  text-align: center;
  font-family: "Amatic SC", cursive;
  font-weight: 700;
  font-size: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  letter-spacing: 1px;
}


ul li {
  /*border: 1px solid var(--color-orange-1);*/
  list-style: none;
}



ol {
  counter-reset: li;
  list-style: none;
  padding: 43px;
  text-shadow: 0 1px 0 rgba(255, 255, 255, .5);
}

ol a {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  margin: .5em 0;
  background: #DAD2CA;
  color: #444;
  text-decoration: none;
  border-radius: .3em;
  transition: .3s ease-out;
}

ol a:hover {
  background: #E9E4E0;
}

ol a:hover:before {
  transform: rotate(360deg);
}

ol a:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: var(--color-orange-1);
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid #fff;
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  transition: all .3s ease-out;
}

table {
  table-layout: fixed;
  max-width: 863px;
  border-collapse: collapse;
  margin: 0% 6%;
  border-spacing: 0px;
  margin: 0;
}

th,
td {
  padding: 0%;

  @media only screen and (max-width: $tablet ) {
    font-size: 0.59rem;
  }

  padding:10px 0;
  letter-spacing: 0px;
  width: 0.2%;
}

tr:nth-child(2n) {
  background-color: var(--color-mozzarella-1);
}

th {
  letter-spacing: 0px;
  background-color: var(--color-orange-1);
  color: #fff;
}




td {
  letter-spacing: 0px;
}

tbody td {
  text-align: center;
}

tfoot th {
  text-align: right;
}

tbody td:nth-child(2) {
  font-family: "jet-regular", "Open Sans", Helvetica, sans-serif;
}
</style>
